exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 896px) {\n.c-btn-wrap[data-v-04862d65] {\n    margin: 0 20px 0 20px\n}\n.c-lyrics-form[data-v-04862d65] {\n    height: 40vh;\n}\n.c-indent-list[data-v-04862d65] {\n    padding: 10px 40px 10px;\n}\n}\n@media screen and (max-width: 896px) {\n.c-lyrics-form[data-v-04862d65] {\n    height: 80vh;\n}\n.c-indent-list[data-v-04862d65] {\n    padding: 10px 20px 10px;\n}\n}\n", ""]);

// exports
